/**
 * Created by hp on 2017/8/9.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {WKShowMore, WKCurrencyItemForIndex} from '../../components/wk';
import { isLZWKAPP } from '../../utils'
import config from '../../config'


class MainMixBox extends Component {
    render() {
        const {mixResources, hasMore, selectCategory, adverts} = this.props;
        let inviterId = selectCategory === 0 ? 43610974 : 43611055

        return (
            <div className={`main-mix-box`}>
                    <div className='feedTitle'>更多精选</div>
                {mixResources.map((v) => {
                        if (!isLZWKAPP()) {
                            return <WKCurrencyItemForIndex content={v} key={v.id} inviterId={inviterId}/>
                        }
                })}

                <WKShowMore loading={hasMore}/>
            </div>
        )
    }
}

export default connect((state) => ({
    mixResources: state.main.recommend.data.ret,
    hasMore: state.main.recommend.data.has_more,
    isShowShuangqian: state.main.isShowShuangqian,
    selectCategory: state.main.selectCategory,
    adverts: state.main.adverts
}))(MainMixBox)


// WEBPACK FOOTER //
// ./src/components/main/MainMixBox.js